<div class="w-100 float-left">
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
        <h5 class="medium m-0" *ngIf="!isEdit">Add Measure </h5>
        <h5 class="medium m-0" *ngIf="isEdit">Edit Measure - {{measureData.measureCode}}</h5>
        <div class="ml-alert"></div>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary" (click)="onBack()">
            <i class="fa fa-arrow-left mr-sm-2"></i> Back
        </button>

    </div>
    <div class="w-100 float-left mt-3">
        <div class='col-lg-6 col-md-6 float-left left-clear'>
            <div class="form-group">
                <label> Name
                    <span class="text-danger medium">*</span>
                </label>
                <input maxlength="200" type="text" class="form-control" [(ngModel)]="measureData.name" name="name"/>
            </div>
        </div>
        <div class='col-lg-6 col-md-6 float-left'>
            <div class="form-group w-100">
                <label for="dropDown">Type</label>
                <select class="form-control light-bg" [(ngModel)]="measureData.targetType">
                    <option value="max">Higher is better</option>
                    <option value="min">Lower is better</option>
                </select>
            </div>
        </div>
        <div class='col-lg-6 col-md-6 float-left left-clear'>
            <div class="form-group">
                <label> Description
                    <span class="text-danger medium"></span>
                </label>
                <textarea maxlength="350" class="form-control" rows="1" [(ngModel)]="measureData.description"
                          name="description"></textarea>
            </div>
        </div>
        <div class='col-lg-6 col-md-6 float-left'>
            <div class="form-group">
                <label for="dropDown">Aggregation</label>
                <select class="form-control light-bg" [(ngModel)]="measureData.aggregator">
                    <option value="sum">Sum</option>
                    <option value="avg">Average</option>
                    <option value="max">Maximum</option>
                    <option value="min">Minimum</option>
                    <option value="count">Count</option>
                    <option value="distinct-count">Distinct-Count</option>
                </select>
            </div>
        </div>
        <div class='col-lg-6 col-md-6 float-left left-clear'>
            <div class="form-group">
                <label> Display Name
                    <span class="text-danger medium">*</span>
                </label>
                <input maxlength="200" type="text" class="form-control" [(ngModel)]="measureData.measureDisplayName"
                       name="name"/>
            </div>
        </div>
        <div class='col-lg-6 col-md-6 float-left'>
            <div class="form-group">
                <label for="dropDown">UOM Relation</label>
                <select class="form-control light-bg" (change)="onSelectUom($event)">
                    <option value="none">None</option>
                    <option *ngFor="let uom of uomList" [attr.value]='uom.id'
                            [attr.selected]="measureData.uomId == uom.id ? true : null">{{uom.name}}
                    </option>
                </select>
            </div>
        </div>
        <div class='col-lg-6 col-md-6 float-left left-clear'>
            <div class="form-group">
                <label for="dropDown">Number Format</label>
                <input maxlength="200" class="form-control" type="text" placeholder="###,###,###"
                       [(ngModel)]="measureData.formatString" id="formula" maxlength="250"/>
            </div>
        </div>
        <div class='col-lg-9 col-md-9 float-left left-clear'>
            <div class="form-group">
                <label>Formula Expression
                    <span *ngIf="formulaMeasure" class="text-danger medium">*</span>
                </label>
                <input autocomplete="off" class="form-control" type="text" [mention]="trgMeasures" id="formula"
                       [(ngModel)]="measureData.formulaExpression"
                       [mentionConfig]="{triggerChar:'`',maxItems:50,labelKey:'name', mentionSelect: onMentionSelect}"
                       placeholder="Formula" maxlength="2000"/>
                <!-- (searchTerm)="onSearchTerm()" <input maxlength="200" class="form-control" type="text" placeholder="Formula" [(ngModel)]="measureData.formulaExpression"
                    id="formula" maxlength="250" /> -->
            </div>
        </div>
        <!-- <div class='col-lg-1 col-md-1 float-left left-clear'>
            <label for="measureData">Rolling</label>
            <div class="form-group">
                <div class='col-sx-8 float-left left-clear'>
                    <input class="checkbox" type="checkbox" name="closingPeriod" [(ngModel)]="measureData.rollup" />
                </div>
            </div>
        </div> -->
        <ng-container *ngIf="measureData.rollup">
            <div class='col-lg-4 col-md-4 float-left left-clear'>
                <label for="dropDown">Aggregation Type</label>
                <select class="form-control light-bg" [ngModel]="measureData.aggType ? measureData.aggType : ''"
                        (ngModelChange)="measureData.aggType = $event">
                    <option value=''>None</option>
                    <option value="sum">Sum</option>
                    <option value="avg">Average</option>
                    <option value="max">Maximum</option>
                    <option value="min">Minimum</option>
                    <option value="count">Count</option>
                    <option value="distinct-count">Distinct-Count</option>
                </select>
            </div>
            <div class='col-lg-4 col-md-4 float-left pl-0'>
                <label for="measureData">Select Dimension Levels</label>
                <select class="form-control light-bg" value='' [ngModel]="''" (change)="selectAggDimLevels($event)">
                    <option value=''>None</option>
                    <option *ngFor="let val of trgDimension" ng-disabled="!val.field" [value]="val.refId">
                        {{getDimName(val.refId)}}
                    </option>
                </select>
            </div>
        </ng-container>
        <ng-container *ngIf="measureData.rollup && selectedDimLvlId.length">
            <div class='col-lg-4 col-md-4 float-left'>
                <label for="measureData">Selected Dimension Levels</label>
                <div class="form-group">
                    <ng-container *ngFor="let dimId of selectedDimLvlId">
                        <div class="card-body">
                            {{getDimName(dimId)}}
                            <!-- <span class="badge badge-secondary">
                                {{((levelMap.get(dim).field) ? levelMap.get(dim).field.displayName : dim
                                    | slice:0:20)+'..'}}
                                {{getDimName(dimId)}}
                            </span> -->&nbsp;
                            <span>
                                <i class="fa fa-times" (click)="removeAggDimLevels(dimId)"></i>
                            </span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <div class='col-lg-9 col-md-9 float-left left-clear'>
            <label>Dimension Filter</label>
            <div class="form-group">
                <div class='col-lg-4 col-md-4 float-left left-clear pl-0'>
                    <!-- <label for="measureData">Select Dimension</label> -->
                    <!-- <input ng2-auto-complete autocomplete="off"  name="orgTypeModel" [source]="trgDimension"
                    [value-formatter]="dimValueFormatter" [list-formatter]="dimListFormatter" value-property-name="field.fieldName"
                    display-property-name="field.fieldName" placeholder="Select Dimension" class="form-control"
                    (valueChanged)="addfilterDim($event)" [ngModel]="filterDim" [accept-user-input]=true blank-option-text="Select"
                    [no-match-found-text]="warning" required> -->
                    <select class="form-control light-bg" [ngModel]="filterDim" (ngModelChange)="addfilterDim($event)">
                        <option [ngValue]="null">None</option>
                        <option *ngFor="let val of trgDimension"
                                ng-selected="(val.displayName ? val.displayName : val.field.fieldName) == filterDim"
                                ng-disabled="!val.field" ng-value="val">
                            {{val.displayName ? val.displayName : val.field ? val.field.displayName : ''}}
                        </option>
                    </select>
                </div>
                <div class='col-lg-4 col-md-4 float-left'>
                    <!-- <label for="measureData">Filter Type</label> -->
                    <select class="form-control light-bg" [(ngModel)]="filterType" (change)="getExistingFilter()">
                        <option ng-selected="filterType == null" [ngValue]="null">None</option>
                        <option ng-selected="filterType == 'inclusion'" ng-value="inclusion">Inclusion</option>
                        <option ng-selected="filterType == 'exclusion'" ng-value="exclusion">Exclusion</option>
                    </select>
                </div>
                <div class='col-lg-4 col-md-4 float-left'>
                    <angular2-multiselect *ngIf="spinner" [data]="trgValues" [ngModel]="filterValue"
                                          [settings]="dimFilterSettings" (onSelect)="addfilterValue($event)"
                                          (onDeSelect)="OnItemDeSelect($event)">
                        <c-item>
                            <ng-template let-item="item">
                                <label>
                                    <span *ngIf="item.name.length > 20" [ngbTooltip]="item.name">
                                        {{(item.name | slice:0:20)+'..'}}
                                    </span>
                                    <span *ngIf="item.name.length <= 20">
                                        {{item.name}}
                                    </span>
                                </label>
                            </ng-template>
                        </c-item>
                        <c-badge>
                            <ng-template let-item="item">
                                <label>
                                    <span *ngIf="item.name.length > 20" [ngbTooltip]="item.name">
                                        {{(item.name | slice:0:20)+'..'}}
                                    </span>
                                    <span *ngIf="item.name.length <= 20">
                                        {{item.name}}
                                    </span>
                                </label>
                            </ng-template>
                        </c-badge>
                    </angular2-multiselect>
                    <i *ngIf="!spinner" class="fa fa-spinner fa-spin"></i>
                </div>
            </div>
        </div>
        <ng-container *ngIf="dimensionFilterList && dimensionFilterList.length && dimensionFilterList.length > 0">
            <div class='card-body col-lg-9 col-md-9 float-left left-clear'>
                <ng-container *ngFor="let dim of dimensionFilterList; let i = index ">
                    <ng-container *ngIf="dim.deleted == undefined || dim.deleted == false">
                        <div class="light-bg col-lg-3 col-md-3 float-left rounded p-2 mt-2 mr-2"
                             (click)="selectDimFilter(dim)">
                            <div class="d-flex align-items-center justify-content-between mb-2 position-relative">
                                <p class="text-truncate"
                                   [innerHTML]="levelMap.get(dim.dimensionLevelId).displayName ? levelMap.get(dim.dimensionLevelId).displayName : levelMap.get(dim.dimensionLevelId).field?.fieldName">
                                </p>
                                <div class="fa fa-times c-p" (click)="removeDimFilter($event,dim)"></div>
                            </div>
                            <p>Filter Type : {{dim.filterType.toUpperCase()}}
                                <!-- <i [ngClass]="{'fa fa-angle-left':dim.filterType == 'inclusion','fa fa-angle-right':dim.filterType == 'exclusion'}"></i> -->
                            </p>
                            <!-- <p>Type: <b>Tree</b></p> -->
                            <p>Values: <b>
                            <p>
                                <ng-container *ngFor="let val of dim.values">
                                            <span *ngIf="val.length > 20" [ngbTooltip]="val">
                                                {{(val | slice:0:20)+'..'}}
                                            </span>
                                    <span *ngIf="val.length <= 20">
                                                {{val}}
                                            </span>&nbsp;&nbsp;
                                </ng-container>
                            </p>
                            </b>
                            </p>
                            <!-- <p>Has All: <b>True</b></p> -->
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
        <ng-container *ngIf="isStarSchema">
            <div class='col-lg-4 col-md-4 float-left mt-2'>
                <label for="measureData">Enable Range : </label>
                <div class="form-group">
                    <div class='col-sx-8 float-left left-clear'>
                        <input class="checkbox" type="checkbox" name="enablerange" [(ngModel)]="measureData.range"/>
                    </div>
                </div>
            </div>
            <div *ngIf="measureData.range" class='col-lg-9 col-md-9 float-left left-clear mt-3'>
                <div class="form-group">
                    <div class='col-lg-4 col-md-4 float-left left-clear pl-0'>
                        <label>Range Start date</label>
                    </div>
                    <div class='col-lg-4 col-md-4 float-left pl-0'>
                        <label>Range End date</label>
                    </div>
                </div>
                <div class="form-group">
                    <ng-container *ngFor="let cubeIdKey of timeDimensionKey">
                        <div class='col-lg-4 col-md-4 float-left left-clear pl-0'>
                            <select class="form-control light-bg" [id]="cubeIdKey+'_'+'key'"
                                    (change)="setTimeFilter($event.target.value, 'startDate')">
                                <option value="">Default</option>
                                <option *ngFor="let dim of timeDimensionMap.get(cubeIdKey)" [attr.value]="dim.dimId"
                                        [attr.selected]="measureData && dim.dimId == measureData.rangeStartDate ? true : null">
                                    {{dim.dimDisplayName && dim.dimDisplayName != '' ? dim.dimDisplayName :
                                    dim.dimName}}
                                </option>
                            </select>
                        </div>
                    </ng-container>
                    <ng-container *ngFor="let cubeIdKey of timeDimensionKey">
                        <div class='col-lg-4 col-md-4 float-left pl-0'>
                            <select class="form-control light-bg" [id]="cubeIdKey+'_'+'key'"
                                    (change)="setTimeFilter($event.target.value, null)">
                                <option value="">Default</option>
                                <option *ngFor="let dim of timeDimensionMap.get(cubeIdKey)" [attr.value]="dim.dimId"
                                        [attr.selected]="measureData && dim.dimId == measureData.rangeEndDate ? true : null">
                                    {{dim.dimDisplayName && dim.dimDisplayName != '' ? dim.dimDisplayName :
                                    dim.dimName}}
                                </option>
                            </select>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <div class='col-lg-4 col-md-4 float-left mt-2'>
            <label for="measureData">Closing Period : </label>
            <div class="form-group">
                <div class='col-sx-8 float-left left-clear'>
                    <input class="checkbox" type="checkbox" name="closingPeriod"
                           [(ngModel)]="measureData.closingPeriod"/>
                </div>
            </div>
        </div>
        <div class='col-lg-8 col-md-8 float-left left-clear mt-2'>
            <div class='col-lg-6 col-md-6 float-left left-clear pl-0'>
                <label for="measureData">Data Version Type</label>
                <select class="form-control light-bg" [(ngModel)]="dataVersionType"
                        (change)="changeDataVersionType($event)">
                    <option ng-selected="dataVersionType=='Dynamic'" ng-value="Dynamic">Dynamic</option>
                    <option ng-selected="dataVersionType=='Static'" ng-value="Static">Static</option>
                </select>
            </div>
        </div>
        <div class='col-lg-8 col-md-8 float-left left-clear mt-2'>
            <div class='col-lg-6 col-md-6 float-left'>
                <label for="cubeStartDate">Start Data Version</label>
                <div class="form-group">
                    <div class='col-sx-8 float-left left-clear'>
                        <input class="form-control light-bg" placeholder="YYYYMMDD" name="startDate" ngbDatepicker
                               [(ngModel)]="startDataVersion" #d="ngbDatepicker" readonly>
                        <ngb-timepicker *ngIf="startDataVersion && startDataVersion.day != undefined"
                                        [ngModel]="startDataVersionTime"
                                        (ngModelChange)="setStartDvTime($event)"></ngb-timepicker>
                    </div>
                    <div class="col-sx-1 float-left">
                        <button class="iga-left form-control light-bg" (click)="d.toggle()" type="button">
                            <i class="fa fa-calendar"></i>
                        </button>
                    </div>
                    <button (click)="clearStartDate()" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
            <div class='col-lg-6 col-md-6 float-left' *ngIf="dataVersionType=='Static'?true:false">
                <label for="measureData">End Data Version</label>
                <div class="form-group">
                    <div class='col-sx-8 float-left left-clear'>
                        <input class="form-control light-bg" placeholder="YYYYMMDD" name="DataVersionDate" ngbDatepicker
                               [(ngModel)]="dataVersionDate" #d="ngbDatepicker" readonly>
                        <ngb-timepicker *ngIf="dataVersionDate && dataVersionDate.day != undefined"
                                        [(ngModel)]="dataVersionTime"
                                        (ngModelChange)="setDvTime($event)"></ngb-timepicker>
                    </div>
                    <div class="col-sx-1 float-left">
                        <button class="iga-left form-control light-bg" (click)="d.toggle()" type="button">
                            <i class="fa fa-calendar"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-left my-4 form-group accordionss">
            <ngb-accordion class="w-100">
                <ngb-panel id="someId" title="Indicators">
                    <ng-template ngbPanelContent>

                        <div class="w-100 float-left mt-3">
                            <div class="col-lg-12 col-md-12 float-right form-group">
                                <button class="btn btn-primary float-left" id="addIndicator"
                                        (click)="addIndicators()">Add
                                    New Indicator
                                </button>
                            </div>
                            <div class="light-bg w-100 float-left p-2 grid-details" *ngIf="indicators.length > 0">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Scale">
                                    <h6 class="mb-lg-0 medium text-truncate"> Scale </h6>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Value">
                                    <h6 class="mb-lg-0 medium text-truncate"> Value </h6>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Colour">
                                    <h6 class="mb-lg-0 medium text-truncate"> Colour </h6>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center"
                                     ngbTooltip="Actions">
                                    <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                                </div>
                            </div>
                        </div>
                        <div class="w-100 float-left p-md-2 grid-details"
                             *ngFor="let indicator of indicators; let i = index">
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                                <h6 class="mb-lg-0 text-truncate">
                                    <input maxlength="200" type="text" maxlength="250" [(ngModel)]="indicator.name"
                                           class="w-full p-sm b-a"/></h6>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                                <h6 class="mb-lg-0 text-truncate">
                                    <input maxlength="200" type="number" [(ngModel)]="indicator.value"
                                           class="w-full p-sm b-a"/></h6>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" *ngIf="!isDimTime">
                                <h6 class="mb-lg-0 text-truncate">
                                    <input type="color" [value]="indicator.code" [attr.id]="i"
                                           (change)="onSelectColor($event,'indicator')"
                                           style="width: 30px; padding: 0 !important;">
                                    <input maxlength="7" type="text"
                                           [value]="indicator.code != undefined ? indicator.code : '' " [attr.id]="i"
                                           (keyup)="onSelectColor($event,'indicator')"/>
                                </h6>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center">
                                <h6 class="mb-lg-0 text-truncate">
                                    <i class="fa fa-trash mr-2" id="delete" [attr.id]="i"
                                       (click)="onIndicatorDelete($event, indicator)"> Delete
                                    </i>
                                </h6>
                            </div>
                        </div>

                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-6 float-left my-4 form-group accordionss">
            <ngb-accordion class="w-100">
                <ngb-panel id="someId" title="Targets">
                    <ng-template ngbPanelContent>
                        <div class="w-100 float-left mt-3">
                            <div class="col-lg-8 col-md-8 float-left left-clear">
                                <button class="btn btn-primary float-left" id="addTarget" (click)="addTarget()">Add New
                                    Target
                                </button>
                            </div>
                            <div class="col-lg-4 col-md-4 float-left">
                                <h6 class="mb-lg-0 text-truncate">
                                    <label> Target Type
                                        <span class="text-danger medium">*</span>
                                    </label>
                                    <select class="form-control" id="trgType" (change)='onSelectTrgType($event)'
                                            [ngModel]="trgType">
                                        <option value='Static'>Static</option>
                                        <option value='Dynamic'>Dynamic</option>
                                        <!-- <option value='Core'>Core</option> -->
                                    </select>
                                </h6>
                            </div>
                        </div>
                        <div class="w-100 float-left mt-3">
                            <div class="light-bg w-100 float-left p-2 grid-details" *ngIf="measureTargets.length > 0">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Target Name">
                                    <h6 class="mb-lg-0 medium text-truncate"> Target Name </h6>
                                </div>
                                <ng-container *ngIf="trgType == 'Static'">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"
                                         ngbTooltip="Target Value">
                                        <h6 class="mb-lg-0 medium text-truncate"> Target Value </h6>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="trgType == 'Dynamic'">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left" ngbTooltip="Measure">
                                        <h6 class="mb-lg-0 medium text-truncate"> Measure </h6>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="trgType == 'Core'">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left" ngbTooltip="Target">
                                        <h6 class="mb-lg-0 medium text-truncate"> Target </h6>
                                    </div>
                                </ng-container>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Colour">
                                    <h6 class="mb-lg-0 medium text-truncate"> Colour </h6>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center"
                                     ngbTooltip="Actions">
                                    <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                                </div>
                            </div>
                        </div>
                        <div *ngFor="let target of measureTargets; let i = index" dnd-sortable-container
                             [sortableData]="measureTargets">
                            <div class="w-100 float-left p-md-2 grid-details" (onDropSuccess)="reorder()" dnd-sortable
                                 [sortableIndex]="i">
                                <!-- <div class="w-100 float-left p-md-2 grid-details" *ngFor="let target of measureTargets; let i = index"> -->
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                                    <h6 class="mb-lg-0 text-truncate">
                                        <input maxlength="200" placeholder="Target Name" type="text" maxlength="250"
                                               [(ngModel)]="target.name" class="form-control"/></h6>
                                </div>
                                <ng-container *ngIf="trgType == 'Static'">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left">
                                        <input maxlength="200" class="form-control" *ngIf='target' type="number"
                                               placeholder="measure target value" id="targetValue" maxlength="250"
                                               [(ngModel)]="target.value"/>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="trgType == 'Core'">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left">
                                        <h6 class="mb-lg-0 text-truncate">
                                            <select class="form-control" id="measureTrg"
                                                    (change)="onSelectTarget($event,i)">
                                                <option>None</option>
                                                <option *ngFor='let trg of corTrgList; let j = index'
                                                        [attr.value]='trg.id'
                                                        [attr.selected]="target.corTargetId == trg.id ? true : null">
                                                    {{trg.name}} ({{trg.corTrgCode}})
                                                </option>
                                            </select>
                                        </h6>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="trgType == 'Dynamic'">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left">
                                        <h6 class="mb-lg-0 text-truncate">
                                            <select class="form-control" (change)="onSelectTrgMeasure($event,i)">
                                                <option>None</option>
                                                <ng-container *ngIf="parent != 'wizard'">
                                                    <option *ngFor='let measure of trgMeasures, let i = index'
                                                            [attr.value]='measure.id'
                                                            [attr.selected]="target.trgMeasureId == measure.id ? true : null">
                                                        {{measure.measureDisplayName}} ({{measure.measureCode}})
                                                    </option>
                                                </ng-container>
                                                <ng-container *ngIf="parent == 'wizard'">
                                                    <option *ngFor='let measure of targetMeasureList, let i = index'
                                                            [attr.value]='measure.measureData.refId'
                                                            [attr.selected]="target.trgMeasureId == measure.measureData.refId ? true : null">
                                                        {{measure.measureData.measureDisplayName}}
                                                        ({{measure.measureData.measureCode}})
                                                    </option>
                                                </ng-container>
                                            </select>
                                        </h6>
                                    </div>
                                </ng-container>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                                    <h6 class="mb-lg-0 text-truncate">
                                        <input type="color" [value]="target.color" [attr.id]="i"
                                               (change)="onSelectColor($event,'target')"
                                               style="width: 30px; height: 30px; padding: 0 !important;">
                                        <input maxlength="7" type="text"
                                               [value]="target.color != undefined ? target.color : '' " [attr.id]="i"
                                               (keyup)="onSelectColor($event,'target')"/>
                                    </h6>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center">
                                    <h6 class="mb-lg-0 text-truncate">
                                        <i class="fa fa-trash mr-2" id="delete" [attr.id]="i"
                                           (click)="onTargetDelete($event, target)">
                                            Delete
                                        </i>
                                    </h6>
                                </div>
                                <!-- </div> -->
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
        <div class="col-lg-2 col-md-2 float-right">
            <button class="btn btn-primary float-right" [disabled]="saveButtonDisable" (click)="save()">Save</button>
        </div>
    </div>
</div>
<div class="w-100 min-h2 relative" *ngIf="loader">
    <loader></loader>
</div>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/measureEdit.component.html